import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { CreateOrderApprovalChainSchema } from '@app/models/users';
import Api from '@app/services/api';

interface IProps {
  data: CreateOrderApprovalChainSchema;
  approval_chain_uid: string;
}

export const useUpdateChainQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ data, approval_chain_uid }: IProps) => {
      await Api.users.putOrderApprovalChain(approval_chain_uid, data);
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: async () => {
      await client.invalidateQueries(['getOrderApprovalChain']);
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
    },
  });
};
